import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const CompanyRedirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  
  if (!slug) {
    return <Navigate to="/companies" replace />;
  }
  
  return <Navigate to={`/companies/${slug}`} replace />;
};

export default CompanyRedirect;